import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from 'hx-util';
export function Divider(_a) {
    var className = _a.className;
    return _jsx("div", { className: cn('rounded-xl h-1 bg-eargo-sinopia', className) });
}
